import {getFormMessages, isRsvp} from '@wix/wix-events-commons-statics'
import {getEvent} from '../../selectors/event'
import {getInvoice} from '../../selectors/placed-order'
import {getPolicies, hasAgreedWithPolicies, shouldShowAlert} from '../../selectors/policies'
import {DetailsPageAppProps} from '../app/interfaces'
import {connect} from '../runtime-context/context'
import {PoliciesOwnProps, PoliciesRuntimeProps} from './interfaces'
import {Policies as Presentation} from './policies'

const mapRuntime = ({
  state,
  actions: {toggleAgreePolicies, openPolicyModal},
}: DetailsPageAppProps): PoliciesRuntimeProps => {
  const event = getEvent(state)
  const rsvp = isRsvp(event)

  return {
    agreedWithPolicies: hasAgreedWithPolicies(state),
    messages: getFormMessages(event),
    rsvp,
    policies: getPolicies(state),
    showAlert: shouldShowAlert(state),
    needsToPay: Number(getInvoice(state).grandTotal.amount) > 0,
    toggleAgreePolicies,
    openPolicyModal,
  }
}

export const Policies = connect<PoliciesOwnProps, PoliciesRuntimeProps>(mapRuntime)(Presentation)
